<template>
    <div class="login">
        <form @submit.prevent="changePassword">
            <p>Email</p>
            <input type="email" v-model="email">
            <p>Current password</p>
            <input :type="show ? 'text' : 'password'" v-model="password">
            <input title="Show" type="checkbox" v-model="show">
            <p>New password</p>
            <input :type="showNew ? 'text' : 'password'" v-model="newPassword">
            <input title="Show" type="checkbox" v-model="showNew">
            <br>
            <input type="submit" value="Change password">
            <pre v-if="result.length > 0">Result: {{ result }}</pre>
        </form>
    </div>
</template>

<script>
import {ref} from 'vue'
import api from "@/api";

export default {
    name: 'ChangePassword',
    data: () => ({
        showNew: false,
        show: false,
    }),
    setup(props) {
        console.log(props)
        let newPassword = ref(''),
            email = ref(''),
            password = ref(''),
            result = ref('');
        const changePassword = async () => {
            let response = await fetch(localStorage.api + 'changePassword', {
                method: 'POST',
                body: JSON.stringify({
                    auth: {
                        email: email.value,
                        password: password.value,
                    },
                    newPassword: newPassword.value,
                }),
                headers: {'Content-Type': 'application/json',},
            });
            result.value = await response.text();
            console.log(result);
        }

        return {
            changePassword,
            newPassword,
            email,
            password,
            result,
        }
    },
}
</script>
<style scoped>
input {
    padding: 10px;
}

input[type='submit'] {
    margin-top: 20px;
}
</style>